export const SOUTH_AFRICAN_TAX_NUMBER_ERROR =
  'Invalid South African tax number. It must be 10 digits.';
export const SOUTH_AFRICAN_VAT_NUMBER_ERROR =
  'Invalid South African VAT number. It must be 10 digits starting with 4.';

export const SOUTH_AFRICAN_TAX_NUMBER_REGEX = /^[1-9][0-9]{9}$/;
export const SOUTH_AFRICAN_VAT_NUMBER_REGEX = /^4[0-9]{9}$/;

export const normalizeTaxOrVatNumber = (value?: string): string => (value ?? '').trim();

export const isValidSouthAfricanTaxNumber = (value?: string): boolean => {
  const normalized = normalizeTaxOrVatNumber(value);
  return SOUTH_AFRICAN_TAX_NUMBER_REGEX.test(normalized);
};

export const isValidSouthAfricanVatNumber = (value?: string): boolean => {
  const normalized = normalizeTaxOrVatNumber(value);
  return SOUTH_AFRICAN_VAT_NUMBER_REGEX.test(normalized);
};

export const validateSouthAfricanTaxNumber = (value?: string): true | string => {
  const normalized = normalizeTaxOrVatNumber(value);

  if (!normalized) {
    return 'Tax number is required';
  }

  return isValidSouthAfricanTaxNumber(normalized) ? true : SOUTH_AFRICAN_TAX_NUMBER_ERROR;
};

export const validateSouthAfricanVatNumber = (value?: string): true | string => {
  const normalized = normalizeTaxOrVatNumber(value);

  if (!normalized) {
    return true;
  }

  return isValidSouthAfricanVatNumber(normalized) ? true : SOUTH_AFRICAN_VAT_NUMBER_ERROR;
};
